import React, { Component } from "react";
import { Tooltip } from "antd";
export default class SocialCongPartB extends Component {
  render() {
    var {
      social_congnition_b_selected_image_1,
      social_congnition_b1_score,
      social_congnition_a1_faverite_object,
      social_congnition_b1_faverite_object,
      social_congnition_b_selected_image_2,
      social_congnition_b2_score,
      social_congnition_a2_faverite_object,
      social_congnition_b2_faverite_object,
      social_congnition_b_selected_image_3,
      social_congnition_b3_score,
      social_congnition_a3_faverite_object,
      social_congnition_b3_faverite_object,
      social_congnition_b_selected_image_4,
      social_congnition_b4_score,
      social_congnition_a4_faverite_object,
      social_congnition_b4_faverite_object,
      social_congnition_b_selected_image_5,
      social_congnition_a5_faverite_object,
      social_congnition_b5_score,
      social_congnition_b_selected_image_6,
      social_congnition_b6_score,
      social_congnition_a6_faverite_object,
      social_congnition_b6_faverite_object,
      social_congnition_score,
      social_congnition_b5_faverite_object,
    } = this.props.data;
    return (
      <div className="row border border-dark">
        <div className="col-lg-12">
          <ul
            style={{
              paddingLeft: 20,
              fontSize: 19,
              paddingTop: 30,
            }}
          >
            <li style={{ listStyle: "square" }}>
              Administration:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Ask the patient to pick which picture the face likes the most.
                  Progress through all questions even when incorrect answers are
                  provided.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Test instructions can be repeated exactly, but DO NOT amend or
                  add to the instructions for this test, for example, do not say
                  ‘which is the face looking at’
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Scoring:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Two points for each correct response. Of the items not
                  correctly identified, score 1 point if answer was NOT the item
                  that participant picked as their own favorite in the previous
                  section, score 0 points if the item WAS picked as their own
                  favorite.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Correct items = 2 points, error = 1 point, egocentric error =
                  0 points.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Say:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  “You are going to see some pictures, one in each corner of a
                  box. You have to choose which picture the face like best.
                  Please say this outloud and respond as quickly as possible’
                </li>
              </ul>
            </li>
          </ul>
          <hr />

          <div className="row">
            <div className="col-lg-6 d-flex flex-wrap align-items-start position-relative">
              <p className="social-cog-para-for-num" style={{ top: 18 }}>
                1){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <img
                  className="face-img"
                  src={require("../../../../../../assets/img/social-cognition-part-a/1/5.png")}
                  alt="scorpion"
                />
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_1 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/1/1.png")}
                        alt="social r 1"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_1 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/1/2.png")}
                        alt="social r 2"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_1 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/1/3.png")}
                        alt="social r 3"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_1 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/1/4.png")}
                        alt="social r 4"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                <div
                  className="answer-box point-box"
                  style={{
                    top: 20,
                    left: 7,
                    marginBottom: 30,
                  }}
                >
                  <table className="social-cognition-table">
                    <tr>
                      <td>
                        <Tooltip title="Egocentric Error = 0 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b1_score"
                            checked={
                              social_congnition_b1_score == "0" ? true : false
                            }
                            disabled={
                              social_congnition_b1_score == "1" ||
                              social_congnition_b1_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>0 Point</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {social_congnition_a1_faverite_object}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Error = 1 Point">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b1_score"
                            checked={
                              social_congnition_b1_score == "1" ? true : false
                            }
                            disabled={
                              social_congnition_b1_score == "0" ||
                              social_congnition_b1_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>1 Point</td>
                      <td>Error</td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Correct Answer = 2 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b1_score"
                            checked={
                              social_congnition_b1_score == "2" ? true : false
                            }
                            disabled={
                              social_congnition_b1_score == "0" ||
                              social_congnition_b1_score == "1"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>2 Point</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {social_congnition_b1_faverite_object}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex flex-wrap align-items-start position-relative">
              <p className="social-cog-para-for-num" style={{ top: 18 }}>
                2){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <img
                  className="face-img"
                  style={{ maxWidth: 106 }}
                  src={require("../../../../../../assets/img/social-cognition-part-a/2/5.png")}
                  alt="scorpion"
                />
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_2 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/2/1.png")}
                        alt="social r 1"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_2 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/2/2.png")}
                        alt="social r 2"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_2 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/2/3.png")}
                        alt="social r 3"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_2 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/2/4.png")}
                        alt="social r 4"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                <div
                  className="answer-box point-box"
                  style={{
                    top: 20,
                    left: 7,
                    marginBottom: 30,
                  }}
                >
                  <table className="social-cognition-table">
                    <tr>
                      <td>
                        <Tooltip title="Egocentric Error = 0 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b2_score"
                            checked={
                              social_congnition_b2_score == "0" ? true : false
                            }
                            disabled={
                              social_congnition_b2_score == "1" ||
                              social_congnition_b2_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>0 Point</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {social_congnition_a2_faverite_object}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Error = 1 Point">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b2_score"
                            checked={
                              social_congnition_b2_score == "1" ? true : false
                            }
                            disabled={
                              social_congnition_b2_score == "0" ||
                              social_congnition_b2_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>1 Point</td>
                      <td>Error</td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Correct Answer = 2 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b2_score"
                            checked={
                              social_congnition_b2_score == "2" ? true : false
                            }
                            disabled={
                              social_congnition_b2_score == "0" ||
                              social_congnition_b2_score == "1"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>2 Points</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {" "}
                        {social_congnition_b2_faverite_object}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex flex-wrap align-items-start position-relative">
              <p className="social-cog-para-for-num" style={{ top: 18 }}>
                3){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <img
                  className="face-img"
                  style={{ maxWidth: 100 }}
                  src={require("../../../../../../assets/img/social-cognition-part-a/3/5.png")}
                  alt="scorpion"
                />
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_3 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/3/1.png")}
                        alt="social r 1"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_3 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/3/2.png")}
                        alt="social r 2"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_3 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/3/3.png")}
                        alt="social r 3"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_3 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/3/4.png")}
                        alt="social r 4"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                <div
                  className="answer-box point-box"
                  style={{
                    top: 20,
                    left: 7,
                    marginBottom: 30,
                  }}
                >
                  <table className="social-cognition-table">
                    <tr>
                      <td>
                        <Tooltip title="Egocentric Error = 0 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b3_score"
                            checked={
                              social_congnition_b3_score == "0" ? true : false
                            }
                            disabled={
                              social_congnition_b3_score == "1" ||
                              social_congnition_b3_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>0 Point</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {social_congnition_a3_faverite_object}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Error = 1 Point">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b3_score"
                            checked={
                              social_congnition_b3_score == "1" ? true : false
                            }
                            disabled={
                              social_congnition_b3_score == "0" ||
                              social_congnition_b3_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>1 Point</td>
                      <td>Error</td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Correct Answer = 2 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b3_score"
                            checked={
                              social_congnition_b3_score == "2" ? true : false
                            }
                            disabled={
                              social_congnition_b3_score == "0" ||
                              social_congnition_b3_score == "1"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>2 Points</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {social_congnition_b3_faverite_object}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex flex-wrap align-items-start position-relative">
              <p className="social-cog-para-for-num" style={{ top: 18 }}>
                4){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <img
                  className="face-img"
                  style={{ maxWidth: 104 }}
                  src={require("../../../../../../assets/img/social-cognition-part-a/4/5.png")}
                  alt="scorpion"
                />
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_4 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/4/1.png")}
                        alt="social r 1"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_4 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/4/2.png")}
                        alt="social r 2"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_4 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/4/3.png")}
                        alt="social r 3"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_4 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/4/4.png")}
                        alt="social r 4"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                <div
                  className="answer-box point-box"
                  style={{
                    top: 20,
                    left: 7,
                    marginBottom: 30,
                  }}
                >
                  <table className="social-cognition-table">
                    <tr>
                      <td>
                        <Tooltip title="Egocentric Error = 0 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b4_score"
                            checked={
                              social_congnition_b4_score == "0" ? true : false
                            }
                            disabled={
                              social_congnition_b4_score == "1" ||
                              social_congnition_b4_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>0 Point</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {social_congnition_a4_faverite_object}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Error = 1 Point">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b4_score"
                            checked={
                              social_congnition_b4_score == "1" ? true : false
                            }
                            disabled={
                              social_congnition_b4_score == "0" ||
                              social_congnition_b4_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>1 Point</td>
                      <td>Error</td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Correct Answer = 2 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b4_score"
                            checked={
                              social_congnition_b4_score == "2" ? true : false
                            }
                            disabled={
                              social_congnition_b4_score == "0" ||
                              social_congnition_b4_score == "1"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>2 Points</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {social_congnition_b4_faverite_object}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex flex-wrap align-items-start position-relative">
              <p className="social-cog-para-for-num" style={{ top: 18 }}>
                5){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <img
                  className="face-img"
                  style={{ maxWidth: 104 }}
                  src={require("../../../../../../assets/img/social-cognition-part-a/5/5.png")}
                  alt="scorpion"
                />
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_5 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/5/1.png")}
                        alt="social r 1"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_5 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/5/2.png")}
                        alt="social r 2"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_5 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/5/3.png")}
                        alt="social r 3"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_5 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/5/4.png")}
                        alt="social r 4"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                <div
                  className="answer-box point-box"
                  style={{
                    top: 20,
                    left: 7,
                    marginBottom: 30,
                  }}
                >
                  <table className="social-cognition-table">
                    <tr>
                      <td>
                        <Tooltip title="Egocentric Error = 0 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b5_score"
                            checked={
                              social_congnition_b5_score == "0" ? true : false
                            }
                            disabled={
                              social_congnition_b5_score == "1" ||
                              social_congnition_b5_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>0 Point</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {social_congnition_a5_faverite_object}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Error = 1 Point">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b5_score"
                            checked={
                              social_congnition_b5_score == "1" ? true : false
                            }
                            disabled={
                              social_congnition_b5_score == "0" ||
                              social_congnition_b5_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>1 Point</td>
                      <td>Error</td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Correct Answer = 2 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b5_score"
                            checked={
                              social_congnition_b5_score == "2" ? true : false
                            }
                            disabled={
                              social_congnition_b5_score == "0" ||
                              social_congnition_b5_score == "1"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>2 Points</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {social_congnition_b5_faverite_object}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-flex flex-wrap align-items-start position-relative">
              <p className="social-cog-para-for-num" style={{ top: 18 }}>
                6){" "}
              </p>
              <div className="social-rec-form-1" style={{ marginLeft: 13 }}>
                <img
                  className="face-img"
                  style={{ maxWidth: 100 }}
                  src={require("../../../../../../assets/img/social-cognition-part-a/6/5.png")}
                  alt="scorpion"
                />
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_6 == "1"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/6/1.png")}
                        alt="social r 1"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_6 == "2"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/6/2.png")}
                        alt="social r 2"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_6 == "3"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/6/3.png")}
                        alt="social r 3"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-6 col-sm-6">
                    <div
                      className={
                        social_congnition_b_selected_image_6 == "4"
                          ? "checkbox-div active"
                          : "checkbox-div"
                      }
                    >
                      <img
                        src={require("../../../../../../assets/img/social-cognition-part-a/6/4.png")}
                        alt="social r 4"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                <div
                  className="answer-box point-box"
                  style={{
                    top: 21,
                    left: 7,
                    marginBottom: 30,
                  }}
                >
                  <table className="social-cognition-table">
                    <tr>
                      <td>
                        <Tooltip title="Egocentric Error = 0 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b6_score"
                            checked={
                              social_congnition_b6_score == "0" ? true : false
                            }
                            disabled={
                              social_congnition_b6_score == "1" ||
                              social_congnition_b6_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>0 Point</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {social_congnition_a6_faverite_object}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Error = 1 Point">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b6_score"
                            checked={
                              social_congnition_b6_score == "1" ? true : false
                            }
                            disabled={
                              social_congnition_b6_score == "0" ||
                              social_congnition_b6_score == "2"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>1 Point</td>
                      <td>Error</td>
                    </tr>
                    <tr>
                      <td>
                        <Tooltip title="Correct Answer = 2 Points">
                          <input
                            className="position-relative"
                            type="checkbox"
                            style={{
                              width: 20,
                              top: 0,
                            }}
                            name="social_congnition_b6_score"
                            checked={
                              social_congnition_b6_score == "2" ? true : false
                            }
                            disabled={
                              social_congnition_b6_score == "0" ||
                              social_congnition_b6_score == "1"
                                ? true
                                : false
                            }
                          />
                        </Tooltip>
                      </td>
                      <td>2 Points</td>
                      <td
                        style={{
                          textTransform: "capitalize",
                        }}
                      >
                        {social_congnition_b6_faverite_object}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <br />
              <span className="fs-19">Score (0 - 12) </span>
              <input
                type="number"
                value={social_congnition_score}
                name="social_congnition_score"
                className="ecas-input-field"
                placeholder="Score"
              />
            </div>
          </div>
          <br />
          <br />
        </div>
      </div>
    );
  }
}
